


















































































































import ActivityDiscountTimer from './activity_discount_timer.vue'
import SeckillActivity from './seckill_activity.vue'
import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  {
    components: {
      SeckillActivity,
      ActivityDiscountTimer,
    },
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 营销数据
      marketingData = computed(() => this.goodsData.value.marketingData)

      // 活动数据
      activityData = computed(() => this.marketingData.value.showTemplate)

      // 商品活动数据
      commodityActivityData = computed(
        () => this.goodsData.value.commodityActivityData,
      )

      // 倒计时信息
      countdownInfo = computed(
        () => this.goodsData.value.discountCountdownInfo,
      )
    },
)
